<template>
  <div class="br-pagebody pd-x-20 pd-sm-x-30">
    <div class="card bd-gray-400">
      <table class="table mg-b-0 table-contact bill data-table">
        <thead>
          <tr>
            <th class="tx-center">{{ $t("other.操作人") }}</th>
            <th class="tx-center">{{ $t("warehouse.日期") }}</th>
            <th class="tx-center">{{ $t("warehouse.SKU/产品名") }}</th>
            <th class="tx-center">{{ $t("order.数量") }}</th>
            <th class="tx-center">{{ $t("warehouse.状态") }}</th>
            <th class="tx-center">{{ $t("mall.备注") }}</th>
            <th class="tx-center">{{ $t("warehouse.仓库名称") }}</th>
            <th class="tx-center">{{ $t("warehouse.库位") }}</th>
            <th class="tx-center">{{ $t("warehouse.变动前库存") }}</th>
            <th class="tx-center">{{ $t("warehouse.变动后库存") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in items" :key="item.id">
            <td class="tx-center valign-middle">{{ item.operatorName }}</td>
            <td class="tx-center valign-middle">
              {{ timeFormat_1(item.createTime) }}
            </td>
            <td class="tx-center valign-middle">
              <div>
                <span>SKU：{{ item.sku }}</span> <br />
                <span>{{ $t("warehouse.产品名") }}：{{ item.skuName }}</span>
              </div>
            </td>
            <td class="tx-center valign-middle">
              {{ Number(item.num).toFixed(0) }}
            </td>
            <td class="tx-center valign-middle">
              <div>
                <span class="text-success" v-if="item.status == 1">增加</span>
                <span class="text-danger" v-if="item.status == 2">减少</span>
              </div>
            </td>
            <td class="tx-center valign-middle">
              <el-tooltip :content="item.remark" placement="top">
                  <i v-if="item.remark" class="icon ion-chatbox-working tx-20 tx-info"></i>
                  <i v-else class="icon ion-chatbox-working tx-20 tx-gray-600"></i>
              </el-tooltip>
            </td>
            <td class="tx-center valign-middle">{{ item.warehouseName }}</td>
            <td class="tx-center valign-middle">{{ item.positionName }}</td>
            <td class="tx-center valign-middle">
              {{ Number(item.beforeNum).toFixed(0) }}
            </td>
            <td class="tx-center valign-middle">
              {{ Number(item.afterNum).toFixed(0) }}
            </td>
          </tr>
          <tr v-if="(!items || items.length < 1) && !first_loading">
            <td colspan="10">
              <div class="col-12 none-product">
                <i class="fa fa-ban"></i
                >{{ $t("warehouse.没有符合条件的仓库流水") }}
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  props: ["first_loading", "items"],
  methods: {
    getLocalTime(nS) {
      return new Date(parseInt(nS) * 1000)
        .toLocaleString()
        .replace(/:\d{1,2}$/, " ");
    },
    // 格式化日期
    timeFormat_1(val) {
      if (!val || val == "0") return "---";
      return moment.unix(Number(val)).format("YYYY-MM-DD");
    },
  },
};
</script>

<style>
</style>
